import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { ITextColumn } from '../../../dashboards/interfaces/tiles/definition-helpers/text-column.interface';
import { ITextColumnsTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/text-columns-tile-definition.interface';
import { VERTICAL_POSITION_OPTIONS } from '../../constants/vertical-position-options.constant';
import { ISelectOption } from '../../interfaces/select-option.interface';
import { TileCreatorHelpersService } from '../../services/tile-creator-helpers.service';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-text-columns-setup-wizard',
  templateUrl: './text-columns-setup-wizard.component.html',
  styleUrls: ['../shared-tile-creator-styles.scss', './text-columns-setup-wizard.component.scss'],
})
export class TextColumnsSetupWizardComponent extends TileSetupWizardComponent<ITextColumnsTileDefinition> {
  verticalPositionsOptions: ISelectOption[];
  fontSizesOptions: string[];

  textColumns;

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorHelpersService: TileCreatorHelpersService,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSelectOptions();
    this.initSetupForms();

    this.hookForm();
  }

  initSelectOptions() {
    this.verticalPositionsOptions = VERTICAL_POSITION_OPTIONS;
    this.fontSizesOptions = this.tileCreatorHelpersService.generateFontSize();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      isTileDividerEnabled: [false],
      tileDividerColor: ['#000000'],
      tileDividerPosition: ['bottom'],
      textColumns: this.fb.array([]),
      background: [''],
    });

    this.textColumns = this.setupForm.controls.textColumns as FormArray;

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);

      this.tileInstance.textColumns?.forEach((textColumn: ITextColumn) => {
        this.addTextColumn(textColumn);
      });
    } else {
      this.addTextColumn();
    }
  }

  addTextColumn(textColumn?: ITextColumn) {
    const textColumnFormGroup = this.fb.group({
      heading: [''],
      headingFontSize: ['6px'],
      headingFontColor: ['#000000'],
      text: [''],
      textFontSize: ['6px'],
      textFontColor: ['#000000'],
      isDividerEnabled: [false],
      dividerColor: ['#000000'],
      dividerPosition: ['top'],
    });

    textColumnFormGroup.patchValue(textColumn);

    (this.setupForm.controls.textColumns as FormArray).push(textColumnFormGroup);
  }

  removeTextColumn(textColumnIndex: number) {
    (this.setupForm.controls.textColumns as FormArray).removeAt(textColumnIndex);
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'text-columns',
      canView: 'true',
      ...this.setupForm.value,
    };
  }
}
